import { parsePercentageString } from "../services/kapital.utils";

export const BalanceSheetBlock: React.FC<{
  koa: string;
  kd_1_minus_t: string;
  ke: string;
  compact: boolean;
  d_empresa: string;
}> = ({ koa, kd_1_minus_t, ke, compact, d_empresa }) => {
  const rawPasivoPerc = parsePercentageString(d_empresa);
  const rawPatrimonioPerc = 100 - rawPasivoPerc;

  const MIN_VISUAL_PERC = 25;
  let visualPasivoPerc = rawPasivoPerc;
  let visualPatrimonioPerc = rawPatrimonioPerc;

  if (visualPasivoPerc < MIN_VISUAL_PERC) {
    visualPasivoPerc = MIN_VISUAL_PERC;
    visualPatrimonioPerc = 100 - MIN_VISUAL_PERC;
  } else if (visualPatrimonioPerc < MIN_VISUAL_PERC) {
    visualPatrimonioPerc = MIN_VISUAL_PERC;
    visualPasivoPerc = 100 - MIN_VISUAL_PERC;
  }

  return (
    <section
      className={`flex flex-col mx-auto w-full ${compact ? 'gap-2' : 'gap-4'}`}
    >
      <main className={`w-full flex ${compact ? 'h-36' : 'h-52'}`}>
        {/* Lado Izquierdo: ACTIVO */}
        <div className="w-1/2 p-0.5">
          <div className="h-full border-[3px] border-[#7b1fa2] rounded-l-xl relative p-1 flex flex-col items-center justify-center shadow-sm">
            <div
              className={`absolute top-1 text-gray-400 text-center w-full uppercase tracking-widest font-bold ${compact ? 'text-[8px]' : 'text-[10px]'}`}
            >
              Activo
            </div>
            <div
              className={`text-center font-bold w-full text-gray-800 ${compact ? 'text-xs mt-2' : 'text-sm mt-4'}`}
            >
              Koa = {koa}
            </div>
          </div>
        </div>

        {/* Lado Derecho: PASIVO Y PATRIMONIO */}
        <div className="w-1/2 flex flex-col p-0.5 gap-1">
          {/* Pasivo (Deuda) */}
          <div
            style={{ height: `calc(${visualPasivoPerc}% - 2px)` }}
            className="border-[3px] border-[#4caf50] rounded-tr-xl relative p-0.5 flex flex-col items-center justify-center shadow-sm transition-[height] duration-500 overflow-hidden"
          >
            <div
              className={`absolute top-1 text-gray-400 text-center w-full uppercase tracking-widest font-bold ${compact ? 'text-[8px]' : 'text-[10px]'}`}
            >
              Pasivo
            </div>
            <div
              className={`text-center w-full font-bold text-gray-800 ${compact ? 'text-xs mt-1' : 'text-sm mt-3'}`}
            >
              Kd(1-T) = {kd_1_minus_t}
            </div>
          </div>

          {/* Patrimonio (Equity) */}
          <div
            style={{ height: `calc(${visualPatrimonioPerc}% - 2px)` }}
            className="border-[3px] border-[#03a9f4] rounded-br-xl relative p-2 flex flex-col items-center justify-center shadow-sm transition-[height] duration-500 overflow-hidden"
          >
            <div
              className={`absolute top-1 text-gray-400 text-center w-full uppercase tracking-widest font-bold ${compact ? 'text-[8px]' : 'text-[10px]'}`}
            >
              Patrimonio
            </div>
            <div
              className={`text-center font-bold w-full text-gray-800 ${compact ? 'text-xs mt-1' : 'text-sm mt-4'}`}
            >
              Ke = {ke}
            </div>
          </div>
        </div>
      </main>

      {/* Leyenda Footer */}
      <footer className="flex w-full justify-between items-center px-1">
        <div className="flex items-center gap-1.5">
          <div className="h-3 w-7 bg-[#03a9f4] rounded-sm shadow-sm"></div>
          <span className="text-[11px] font-bold text-gray-600 uppercase tracking-tight">Ke</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="h-3 w-7 bg-[#7b1fa2] rounded-sm shadow-sm"></div>
          <span className="text-[11px] font-bold text-gray-600 uppercase tracking-tight">Koa</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="h-3 w-7 bg-[#4caf50] rounded-sm shadow-sm"></div>
          <span className="text-[11px] font-bold text-gray-600 uppercase tracking-tight">
            Kd*(1-T)
          </span>
        </div>
      </footer>
    </section>
  );
};
